import {
    createRouter,
    createWebHistory
} from "vue-router";

const routes = [
    {
        path: "/authentication",
        name: "Authentication",
        component: () =>
            import("@/pages/AuthenticationPage.vue"),
    },

    {
        path: "/",
        component: () =>
            import("@/layouts/AuthorizedLayout.vue"),

        children: [
            {
                path: "",
                name: "Start",
                component: () =>
                    import("@/pages/StartPage.vue"),

                meta: {
                    headerPageSetting: "start-page",
                    layoutBackground: "clouds"
                },
            },

            {
                path: "information",
                name: "Information",
                component: () =>
                    import("@/pages/InformationPage.vue"),

                meta: {
                    headerPageSetting: "with-title",
                    headerTitle: "Как читать прогноз",
                },
            },

            {
                path: "company",
                name: "Company",
                component: () =>
                    import("@/pages/CompanyPage.vue"),

                meta: {
                    requiresAuth: true,
                    roles: ["company-user"],
                    showCompanyName: true,
                },
            },

            {
                path: "administration",
                name: "Administration",
                component: () =>
                    import("@/pages/AdministrationPage.vue"),

                meta: {
                    requiresAuth: true,
                    roles: ["admin"],
                    headerPageSetting: "company-selector",
                },
            },

            {
                path: "profile",
                name: "Profile",
                component: () =>
                    import("@/pages/ProfilePage.vue"),

                meta: {
                    requiresAuth: true,
                    headerPageSetting: "with-title",
                    headerTitle: "Личный кабинет",
                },
            },
        ],
    },
];

export const router = createRouter({
    history: createWebHistory(),
    routes,

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return {
                el: to.hash,
                behavior: "smooth",
            };
        }

        return {
            top: 0,
        };
    },
});